// extracted by mini-css-extract-plugin
module.exports = {"ourIndustriesSection":"h_s","industriesContainer":"h_t","industriesItem":"h_v","description":"h_k","industryTitle":"h_w"};